import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormPageConfig } from '../../../models/form-page-config';
import { LFDynamicWidgetConfig } from '../../../models/lf-dynamic-widget-config';
import { ResourceService } from 'sce-core';
import { DetailedEntityDataService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-data.service';
import { DetailedEntityButtonService } from '../../../services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { SearchableEntityDataEditorService } from '../../../services/searchable-entity/searchable-entity-data-editor.service';
import { DetailViewKeyEventHandlerService } from '../../../services/detail-view-key-event-handler.service';
import { DynamicWidget } from '../dynamic-widget';
import { ColumnLayoutSecWidgetComponent } from '../column-layout-sec-widget/column-layout-sec-widget.component';
import { StorerDataService } from '../../../../features/setup/customer/storer/services/storer-data.service';
import { SearchService } from '../../../search/search.service';
import { Observable } from 'rxjs/Observable';
import { AbstractFormWidgetComponent } from '../abstract-form-widget/abstract-form-widget.component';
import { StorerButtonService } from '../../../../features/setup/customer/storer/services/storer-button.service';
import { SearchEvent } from '../../../search/models/search-event';
import { NEW_ROW_EVENT, NEW_SEARCH_EVENT, PAGE_OVERFLOW_EVENT } from '../../../search/search-constants';

@Component({
  selector: 'lfwms-storer-additional-info-widget',
  templateUrl: './additional-info-widget.html',
  styleUrls: ['./additional-info-widget.css']
})
export class StorerAdditionalInfoWidgetComponent extends AbstractFormWidgetComponent implements OnInit {

  public searchService: SearchService;
  public dataService: StorerDataService;
  public buttonService: StorerButtonService;
  public tabbedSearchServices: Array<SearchService> = [];
  public selectedTab: string = '0';
  public tabHeaders: Array<string> = ['Consignee SKU', 'Delivery Date'];
  public isDataLoaded: boolean = false;
  public maxRow: number;

  public ngOnInit() {
    this.buttonService = <StorerButtonService>this.pageConfig.buttonService;
    this.initializeWidget();
    this.renderSelectedTab();
  }

  // LFWM-441 method for handling tab change
  public onTabChange(tabIndex): boolean {
    this.selectedTab = tabIndex;
    this.renderSelectedTab();
    return true;
  }

  public renderSelectedTab() {
    this.tabbedSearchServices[this.selectedTab].clearSearchStatus();
    if (this.dataService.displayMode === 'C') {
      // this.tabbedSearchServices[this.selectedTab].createNewRow();
    } else {
      this.tabbedSearchServices[this.selectedTab].setSearchCriteria({
        conditions: [{
          mandatory: false,
          clauses: [{
            column: 'storerKey',
            operation: '=',
            value: this.dataService.getPrimarySelectedDocument(),
            logicalOperation: null
          }],
          logicalOperation: null
        }]
      });
      this.tabbedSearchServices[this.selectedTab].performSearch();
      this.isDataLoaded = true;
    }
    this.tabbedSearchServices[this.selectedTab].receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
        if (event.type === NEW_SEARCH_EVENT &&
          this.tabbedSearchServices[this.selectedTab].getMetadata()) {
          // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
          this.pageConfig.isDetailSectionLoaded = true;
        } else if (event.type === NEW_ROW_EVENT) {
          const newRow = event.selectedRow.cells;
          if (this.selectedTab === '1') {
            if(!this.maxRow){
              this.tabbedSearchServices[this.selectedTab].getPagedData().pageRows.forEach((row: any) => {
                this.maxRow  = parseInt(row.cells['priority'].cVal);
              });
              newRow['priority'].cVal = this.maxRow + 1;
            } else {
              newRow['priority'].cVal = this.maxRow + 1;
            }
            this.maxRow = this.maxRow + 1;
          }
            if(newRow['storerKey']){
              newRow['storerKey'].cVal = this.dataService.primaryDataMap['storerType'].cVal === '2' 
                                        ? this.dataService.primaryDataMap['consigneeName'].cVal
                                        : this.dataService.primaryDataMap['storerKey'].cVal;
            }
            if(newRow['consigneeKey']){
              newRow['consigneeKey'].cVal = this.dataService.primaryDataMap['storerType'].cVal === '2'
                                            ? this.dataService.primaryDataMap['storerKey'].cVal
                                           :this.dataService.primaryDataMap['consigneeName'].cVal;
            }
          // For NEW_ROW_EVENT
          // for new row event the search service should also be passed to distinguish between the two tables
          this.dataService.handleAddNewItem(event, this.tabbedSearchServices[this.selectedTab]);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.tabbedSearchServices[this.selectedTab].setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
  }

  protected initializeWidget() {
    // this is not to be loaded from the primary data map, hence initializing it
    // this.pageConfig.cellDataMap = {};
    super.initializeWidget();
    this.initializeSearchServices();
  }

  public initializeSearchServices() {
    this.tabbedSearchServices[0] = this.dataService.getSearchServiceForColumnGroup(this.widgetConfig.id, '0');
    this.tabbedSearchServices[1] = this.dataService.getSearchServiceForColumnGroup(this.widgetConfig.id, '1');
  }

  // realigns the widget
  public realignWidget() {
    //  this.propertyList = this.preparePropertyGrid(this.widgetConfig.propertyList, this.getCellsPerRow());
  }


}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/additional-info-widget/additional-info-widget.ts